import { render } from "./device-select.vue?vue&type=template&id=bc969b56"
import script from "./device-select.vue?vue&type=script&lang=js"
export * from "./device-select.vue?vue&type=script&lang=js"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\BrikTok\\SpliytGit\\SpliytAdminPortal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__